exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sound-warning{position:absolute;right:-40%;bottom:7%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-822a6350!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Splash.vue
// module id = 49
// module chunks = 1